/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */
import { HubBootstrapQuery } from '@atlassian/company-hub-common';
import HubQuery from '../../ui/hub/__generated__/hubQuery.graphql';
import { createRelayResource, getPageAri } from './utils';
export var hubBootstrapResource = createRelayResource({
  getQuery: function getQuery(_ref, _ref2) {
    var match = _ref.match;
    var cloudId = _ref2.cloudId,
      helpCenterAri = _ref2.helpCenterAri;
    var pageId = match.params.id || '';
    return {
      variables: {
        cloudId: cloudId,
        hubAri: helpCenterAri,
        pageAri: getPageAri(helpCenterAri, pageId),
        operationType: 'READ'
      },
      query: HubBootstrapQuery,
      options: {
        fetchPolicy: 'store-or-network'
      }
    };
  }
});
export var hubPageResource = createRelayResource({
  getQuery: function getQuery(_ref3, _ref4) {
    var match = _ref3.match;
    var cloudId = _ref4.cloudId,
      helpCenterAri = _ref4.helpCenterAri;
    var pageId = match.params.id || '';
    return {
      variables: {
        cloudId: cloudId,
        hubAri: helpCenterAri,
        pageAri: getPageAri(helpCenterAri, pageId)
      },
      query: HubQuery,
      options: {
        fetchPolicy: 'store-or-network'
      }
    };
  }
});